export default function SectionBadge({ icon, label }: { icon: string; label: string }) {
  return (
    <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[var(--color-accent-oil)]/50 text-[var(--color-accent-oil)] text-[11px] font-semibold uppercase tracking-[0.15em]">
      <i className={`${icon} text-sm`}></i>
      {label}
    </span>
  );
}
